import { connect } from "react-redux";
import { setWarningMessage } from "../messages/actions";
import { changePassword } from "../users/loggedUser/actions";
import ChangePasswordComponent from "../components/ChangePasswordComponent";
import { isDemo } from "../users/selectors";
import { translate } from "react-i18next";
const mapStateToProps = state => ({
  phase: state.account.phase,
  isDemo: isDemo(state)
});

const mapDispatchToProps = dispatch => ({
  onSubmit: values => {
    if (!values.oldPassword) {
      dispatch(setWarningMessage("changePassword:currentPasswordWarningText"));
      return;
    }
    if (!values.password) {
      dispatch(setWarningMessage("changePassword:newPasswordWarningText"));
      return;
    }
    if (!values.confirmpassword) {
      dispatch(
        setWarningMessage("changePassword:confirmNewPasswordWarningText")
      );
      return;
    }
    if (values.password !== values.confirmpassword) {
      dispatch(setWarningMessage("changePassword:notMatchPasswordWarningText"));
      return;
    }

    dispatch(changePassword(values));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(ChangePasswordComponent));



// WEBPACK FOOTER //
// ./src/containers/ChangePasswordContainer.js